import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { arrive, flushQueued, portal } from "./Player";
import { BAND, SECTIONS } from "../../lib/sections";

// A soft wash of the room's colour while the visitor passes through a portal.
export function PortalVeil() {
  const [t, setT] = useState(null);
  useEffect(() => {
    const on = (e) => setT({ id: e.detail, phase: "in" });
    window.addEventListener("afae-portal", on);
    return () => window.removeEventListener("afae-portal", on);
  }, []);
  if (!t) return null;
  const col = BAND[t.id] || "#F3E3F0";
  const name = SECTIONS[t.id]?.name || (t.id === "memory" ? "the Memory Wall" : t.id === "windows" ? "the Living Windows" : "the Feeling Wall");
  const done = () => {
    if (t.phase === "in") {
      arrive(t.id);
      setT({ ...t, phase: "out" });
    } else {
      portal.on = false;
      setT(null);
      flushQueued();
    }
  };
  return (
    <motion.div
      data-testid="portal-veil"
      data-target={t.id}
      className="pointer-events-none fixed inset-0 z-30 flex items-center justify-center"
      style={{ background: `radial-gradient(circle at 50% 45%, #FFF8EE 0%, ${col} 85%)` }}
      initial={{ opacity: 0 }}
      animate={{ opacity: t.phase === "in" ? 1 : 0 }}
      transition={{ duration: t.phase === "in" ? 0.5 : 0.8 }}
      onAnimationComplete={done}
    >
      <span className="font-display text-4xl italic text-[#4A2D55]/80 sm:text-5xl">{name}</span>
    </motion.div>
  );
}
